module.exports = __webpack_public_path__ + "img/xzybtm.b990a744.png";